/**
 * Thuysvers Survey Form - Klaviyo / Gadget progress tracking
 * Sends "started" and "completed" events to Gadget for Klaviyo profile updates.
 * Depends on: thuysvers-survey-form-utils.js (must load first)
 */
(function () {
  'use strict';

  const Utils = /** @type {NonNullable<typeof window.ThuysversSurveyFormUtils>} */ (window.ThuysversSurveyFormUtils);
  if (!Utils) {
    console.warn('[THUYSVERS-KLAVIYO] ThuysversSurveyFormUtils not loaded; Klaviyo tracking disabled');
  }

  /**
   * Sends a "started" or "completed" event to Gadget for Klaviyo profile updates.
   * @param {{ formEl?: HTMLFormElement | null }} ctx - Survey form context
   * @param {'started'|'completed'} status
   * @param {string} email
   * @param {Record<string, unknown>} [extra]
   * @returns {Promise<void>}
   */
  async function sendSurveyProgress(ctx, status, email, extra) {
    if (!Utils) return;
    const endpoint = Utils.getGadgetProgressEndpoint(ctx);
    if (!endpoint) return;

    const form = ctx.formEl;
    const shopId = form ? (String(form.getAttribute('data-shop-id') || '').trim() || undefined) : undefined;

    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          status,
          email,
          occurredAt: new Date().toISOString(),
          ...(shopId ? { shopId } : {}),
          ...(extra || {}),
        }),
      });
      if (!res.ok) {
        console.warn('[THUYSVERS-SURVEY] Survey progress request failed', { status: res.status });
      }
    } catch (error) {
      console.warn('[THUYSVERS-SURVEY] Survey progress request errored', error);
    }
  }

  /**
   * Marks survey as started once per email in this session; skips if already completed.
   * @param {object} ctx - Survey form context
   * @param {{ storageKeyStarted: string; storageKeyCompleted: string; emailRegex: RegExp }} opts
   * @returns {Promise<void>}
   */
  async function maybeTrackSurveyStarted(ctx, opts) {
    if (!Utils) return;
    const email = Utils.getSubmitterEmailFromForm(ctx);
    if (!email || !opts.emailRegex.test(email)) return;

    try {
      const prev = sessionStorage.getItem(opts.storageKeyStarted) || '';
      const completed = sessionStorage.getItem(opts.storageKeyCompleted) || '';
      if (completed && completed === email) return;
      if (prev && prev === email) return;

      sessionStorage.setItem(opts.storageKeyStarted, email);
    } catch {
      // Ignore storage failures
    }

    await sendSurveyProgress(ctx, 'started', email);
  }

  const klaviyoExport = {
    sendSurveyProgress,
    maybeTrackSurveyStarted,
  };

  window.ThuysversSurveyFormKlaviyo = klaviyoExport;
})();
